import { EventTarget } from 'event-target-shim';
/**
 * Typed proxy for CustomEvent to guarantee type and payload match
 * Adapted from https://medium.com/scout24-engineering/typesafe-customevents-on-your-frontend-b3265aff6cf0
 */
export const assetStoreEvent = (name, payload) => new CustomEvent(name, payload);
/**
 * UploadEventTarget needs to casted, so it can be extended from
 */
export const AssetStoreEventTarget = class AssetStoreEventTarget extends EventTarget {
};
//# sourceMappingURL=assetStoreEvent.js.map